import InfoIcon from "@mui/icons-material/Info";
import { Box, Tooltip, Typography } from "@mui/material";
import { SelectOption } from "components/SelectInput";
import { getHighestRole } from "code/roleHelpers";
import { Role } from "enums/Role";

export default function RolesCell({
	roles,
	roleOptions
}: {
	roles: Role[];
	roleOptions: SelectOption[];
}) {
	if (!roles || roles.length === 0) {
		return <Typography variant="text14">-</Typography>;
	}

	const getLabel = (value: Role) => roleOptions.find((o) => o.value === value)?.label ?? value;

	const highestRole = getHighestRole(roles);
	const otherCount = roles.length - 1;

	return (
		<Box sx={{ display: "flex", alignItems: "center" }}>
			<Typography variant="text14">{getLabel(highestRole)}</Typography>
			{otherCount > 0 && (
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						width: "100%",
						gap: 1
					}}
				>
					<Box>{`, +${otherCount}`}</Box>
					<Tooltip
						title={roles.map((role, i) => (
							<div key={`${role}-${i}`}>{getLabel(role)}</div>
						))}
						arrow
					>
						<InfoIcon
							fontSize="small"
							sx={{
								color: "text.secondary",
								cursor: "pointer",
								fontSize: 16
							}}
						/>
					</Tooltip>
				</Box>
			)}
		</Box>
	);
}
